<template>
  <div style="overflow:auto;width:fit-content;margin:auto;">
    <v-layout justify-center align-center v-for="row in rows" :key="row">
      <div
        style="padding: 3px"
        v-for="col in cols"
        :key="col"
        @click.stop="onSeatSelected(_seatId(row, col))"
        @contextmenu.prevent="$refs.contextMenu.open($event, {row: row, col: col})"
      >
        <Seat
          hover
          :label="_seatLabel(_seatId(row, col))"
          :color="_classifier(_seatId(row, col))"
          :labelFontColor="
            _isSeatSelected(_seatId(row, col))
              ? 'white--text'
              : 'grey--text text--darken-3'
          "
          :isContextMenuVisible="isContextMenuVisible"
        ></Seat>
      </div>
    </v-layout>
    <!-- Context menu -->
    <vue-context class="pt-0" ref="contextMenu" v-slot="{ data }" @close="_setContextMenuVisibility(false)" @open="_setContextMenuVisibility(true)">
      <div>
        <v-list class="pt-0">
          <!-- Selections action -->
          <template >
            <v-subheader>{{
              $t("venue.seat.context.menu.selection.title")
            }}</v-subheader>
            <v-list-tile @click="$emit('onSelectRow',data)">
              <v-list-tile-action>
                <v-icon>mdi-table</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.selection.select_row.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('onSelectColumn', data)">
              <v-list-tile-action>
                <v-icon>mdi-table-column-width</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.selection.select_column.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('onSelectAll')">
              <v-list-tile-action>
                <v-icon>mdi-table-edit</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.selection.select_all.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :disabled="!selectedSeats.length"  @click="$emit('resetSelections')">
              <v-list-tile-action >
                <v-icon :disabled="!selectedSeats.length">mdi-select-off</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.selection.reset_selection.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <!-- Mark Seat Types -->
          <template v-if="selectedSeats.length">
            <v-subheader>{{
              $t("venue.seat.context.menu.assign_seat_type.title")
            }}</v-subheader>
            <v-list-tile @click="updateSeatType(DEFINES.SEAT_CATEGORIES_VALUE['REGULAR'])">
              <v-list-tile-action>
                <v-icon>mdi-seat-recline-extra</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.regular_seats.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="updateSeatType(DEFINES.SEAT_CATEGORIES_VALUE['CHEAPER'])">
              <v-list-tile-action>
                <v-icon>mdi-account</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.cheaper_seats.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="updateSeatType(DEFINES.SEAT_CATEGORIES_VALUE['PREMIUM'])">
              <v-list-tile-action>
                <v-icon>mdi-seal</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.premium_seats.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="updateSeatType(DEFINES.SEAT_CATEGORIES_VALUE['DISABLED'])">
              <v-list-tile-action>
                <v-icon>mdi-wheelchair-accessibility</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.disabled_seats.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('markUnavailableSeats')">
              <v-list-tile-action>
                <v-icon>mdi-close</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.not_available.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="notForSaleSeats && notForSaleSeats.length" @click="$emit('markAvailableSeats')">
              <v-list-tile-action>
                <v-icon>mdi-sale</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>{{
                  $t("venue.seat.context.menu.mark.available_for_sale.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <template v-if="selectedSeats.length">
            <v-subheader>{{
              $t("venue.seat.context.menu.edit_seat.title")
            }}</v-subheader>
             <v-list-tile @click="$emit('deleteSelected')">
              <v-list-tile-action>
                <v-icon color="error lighten-1">mdi-delete</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="error--text text--lighten-1">{{
                  $t("venue.seat.context.menu.delete_seat.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('allowSelected')">
              <v-list-tile-action>
                <v-icon color="success lighten-1">mdi-selection</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="success--text text--lighten-1">{{
                  $t("venue.seat.context.menu.allow_seat.title")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </div>
    </vue-context>
  </div>
</template>
<script>
import Seat from "./SingleSeat";
import SeatTypeLabels from "./SeatTypeLabels.vue";
import { seatMethods, seatCategoryMethods } from "@/mixins/seats";
import { currencySymbol } from "@/mixins/currencySymbol";
import VueContext from "vue-context";
import "vue-context/src/sass/vue-context.scss";
export default {
  name: "SeatMatrix",
  props: {
    maxHeight: {
      type: String,
      default: "500px",
    },
    maxWidth: {
      type: String,
      default: "500px",
    },
    showSeatType: {
      type: Boolean,
      default: true,
    },
    seats: {
      type: Object,
      default: {},
    },
    reservedSeats: {
      type: Object,
      default: {},
    },
    seatsStatus: {
      type: Object,
      default: {},
    },
    selectedSeats: {
      type: Array,
      default: [],
    },
    notForSaleSeats: {
      type: Array,
      default: [],
    },
    seatPricing: {
      type: Object,
      default: null,
    },
    rows: Number,
    cols: Number,
  },
  data() {
    return {
      isContextMenuVisible:false
    };
  },
  mixins: [seatMethods, seatCategoryMethods, currencySymbol],
  components: {
    Seat,
    VueContext,
    SeatTypeLabels,
  },
  methods: {
    /** Returns suitable class according to status/category @return String */
    _classifier(seatId) {
      if (!this._isSeatExists(seatId)) {
        return;
      }

      if (this._isSeatSelected(seatId)) {
        return "green lighten-2";
      }

      if (this._isNotForSale(seatId)) {
        return "grey darken-2";
      }
      
      if (!this._isSeatAccessible(seatId)) {
        return "grey lighten-2";
      }


      if (!this._seatStatus(seatId)) {
        let category = this._categoryClassifier(this._seatCategory(seatId));
        return category.color;
      }

      //FIXME: preapare for both types
      // switch (this._seatStatus(seatId)) {
      //   case this.DEFINES.SEATS_STATUS.AVAILABLE:
      //     if (this._isSeatSelected(seatId)) {
      //       return "cls-seat-selected";
      //     }
      //     let category = this._categoryClassifier(this._seatCategory(seatId));
      //     return category.colorClass;
      //   case this.DEFINES.SEATS_STATUS.LOCKED:
      //     return "cls-seat-reserved";
      //   case this.DEFINES.SEATS_STATUS.BOOKED:
      //     return "cls-seat-booked";
      //   default:
      //     return "cls-seat-available";
      // }
    },
    /** Returns seat status @return Number|String 10|20|30|... */
    _seatStatus(seatId) {
      if (!this.seatsStatus.hasOwnProperty(seatId)) {
        return;
      }
      return this.seatsStatus[seatId]["status"];
    },
    /** Prepare & returns HTML string @return String */
    _seatTooltipContent(seatId) {
      let seatLabel = this._seatLabel(seatId);
      let seatCategory = this._categoryClassifier(this._seatCategory(seatId));
      let seatPrice =
        this.getCurrencySymbol(this.company.currency) + this._seatPrice(seatId);

      return (
        this.$t("screener.seats.label.title") +
        " : <b>" +
        seatLabel +
        "</b><br/>" +
        this.$t("screener.seats.category.title") +
        " : <b>" +
        seatCategory.label +
        "</b><br/>" +
        this.$t("screener.seats.price.title") +
        " : <b>" +
        seatPrice +
        "</b>"
      );
    },
    onSeatSelected(seatId) {
      this.$emit("onSeatSelected", seatId);
    },
    updateSeatType(category) {
      this.$emit("updateSeatType", category);
    },
    _isNotForSale(seatId){
      if(!this.notForSaleSeats){
        return false;
      }
      const notForSaleArray = Object.values(this.notForSaleSeats);
      return notForSaleArray.includes(seatId);
    },
    _setContextMenuVisibility(isVisible=false){
      this.isContextMenuVisible = isVisible;
    }
  },
};
</script>
<style scoped>
.scroll-x {
  overflow-x: scroll;
}
.scroll-y {
  overflow-y: scroll;
}
.theater-screen {
  border-top: 4em solid rgba(0, 0, 0, 0.1);
  border-left: 3em solid transparent;
  border-right: 3em solid transparent;
  height: 0;
  width: 100%;
}
>>>.v-list__tile{
  height:35px;
}
</style>
